import { CSS, Transform } from '@dnd-kit/utilities';
import styled, { css } from 'styled-components';

export const DragHandleContainer = styled.div`
  display: flex;
  align-items: flex-start;

  padding-top: ${({ theme }) => theme.spacing(0.25)};

  transition: opacity 200ms;

  // Only hidden where hover exists — on touch there is no gesture that would bring it back.
  @media (any-hover: hover) {
    opacity: 0;

    &:focus-within {
      opacity: 1;
    }
  }
`;

export const SortableContainer = styled.div<{
  $isDragging: boolean;
  $transform: Transform | null;
  $transition?: string;
}>`
  position: relative;
  transform: ${({ $transform }) => CSS.Translate.toString($transform)};
  transition: ${({ $transition }) => $transition};

  // No drag overlay here: the row itself follows the cursor, so it has to paint above its later siblings.
  ${({ $isDragging }) =>
    $isDragging &&
    css`
      z-index: 1;

      ${DragHandleContainer} {
        opacity: 1;
      }
    `};
`;

export const Container = styled.div<{
  $isSelected?: boolean;
  $isDisabled?: boolean;
  $isContextMenuOpen?: boolean;
}>`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(1.5)}`};

  border-radius: ${({ theme }) => theme.spacing(2)};

  background: ${({ theme }) => theme.palette.background.default};

  @media (any-hover: hover) {
    &:hover ${DragHandleContainer} {
      opacity: 1;
    }
  }

  ${({ $isSelected, theme }) =>
    $isSelected &&
    css`
      background: ${theme.palette.background.paper};
    `};

  ${({ $isContextMenuOpen, theme }) =>
    $isContextMenuOpen &&
    css`
      background: ${theme.palette.grey[100]};
    `};

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      pointer-events: none;
    `};
`;

export const CheckboxContainer = styled.div<{ $isFaded?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;

  padding-top: ${({ theme }) => theme.spacing(0.25)};
  width: 2rem;
  height: 2rem;
  min-width: 2rem;
  min-height: 2rem;

  line-height: 62.5%;
  font-size: 2rem;

  ${({ theme }) =>
    theme.isMobile &&
    css`
      width: 3.2rem;
      height: 3.2rem;
      min-width: 3.2rem;
      min-height: 3.2rem;
    `};

  ${({ $isFaded }) =>
    $isFaded &&
    css`
      opacity: 0.3;
    `};
`;

export const TitleContainer = styled.div<{ $isFaded?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.75)};
  min-width: 0;

  line-height: 1;

  ${({ $isFaded, theme }) =>
    $isFaded &&
    css`
      opacity: 0.5;
      color: ${theme.palette.text.secondary};
    `}

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding-top: ${({ theme }) => theme.spacing(1.5)};
    `};
`;
